import { ExamType, CurrentLevel, Goal, Subject, TimeSlot } from '../types/study-plan';

export const EXAM_TYPES: ExamType[] = [
  {
    id: 'neet',
    name: 'NEET',
    description: 'National Eligibility cum Entrance Test for Medical'
  },
  {
    id: 'jee-mains',
    name: 'JEE-MAINS',
    description: 'Joint Entrance Examination - Main'
  },
  {
    id: 'jee-advance',
    name: 'JEE-ADVANCE',
    description: 'Joint Entrance Examination - Advanced'
  }
];

export const CURRENT_LEVELS: CurrentLevel[] = [
  {
    id: 'beginner',
    name: 'BEGINNER',
    description: 'Just starting preparation'
  },
  {
    id: 'exam-attempted',
    name: 'EXAM ATTEMPTED - NOT QUALIFIED',
    description: 'Previously attempted but did not qualify'
  },
  {
    id: 'exam-qualified',
    name: 'EXAM QUALIFIED - LOW SCORE',
    description: 'Qualified with low score, aiming for improvement'
  }
];

export const GOALS: Goal[] = [
  {
    id: 'total-score',
    type: 'total',
    name: 'TOTAL SCORE INPUT NEEDED',
    description: 'Focus on overall score improvement'
  },
  {
    id: 'individual-subject',
    type: 'individual',
    name: 'INDIVIDUAL SUBJECT SCORE NEEDED',
    description: 'Focus on specific subject improvements'
  }
];

export const SUBJECTS: Subject[] = [
  {
    id: 'physics',
    name: 'Physics',
    chapters: [
      { id: 'mechanics', name: 'Mechanics', subjectId: 'physics' },
      { id: 'thermodynamics', name: 'Thermodynamics', subjectId: 'physics' },
      { id: 'optics', name: 'Optics', subjectId: 'physics' },
      { id: 'electricity', name: 'Electricity & Magnetism', subjectId: 'physics' },
      { id: 'modern-physics', name: 'Modern Physics', subjectId: 'physics' },
      { id: 'waves', name: 'Waves & Sound', subjectId: 'physics' }
    ]
  },
  {
    id: 'chemistry',
    name: 'Chemistry',
    chapters: [
      { id: 'organic', name: 'Organic Chemistry', subjectId: 'chemistry' },
      { id: 'inorganic', name: 'Inorganic Chemistry', subjectId: 'chemistry' },
      { id: 'physical', name: 'Physical Chemistry', subjectId: 'chemistry' },
      { id: 'environmental', name: 'Environmental Chemistry', subjectId: 'chemistry' },
      { id: 'coordination', name: 'Coordination Compounds', subjectId: 'chemistry' },
      { id: 'surface', name: 'Surface Chemistry', subjectId: 'chemistry' }
    ]
  },
  {
    id: 'mathematics',
    name: 'Mathematics',
    chapters: [
      { id: 'algebra', name: 'Algebra', subjectId: 'mathematics' },
      { id: 'calculus', name: 'Calculus', subjectId: 'mathematics' },
      { id: 'geometry', name: 'Coordinate Geometry', subjectId: 'mathematics' },
      { id: 'trigonometry', name: 'Trigonometry', subjectId: 'mathematics' },
      { id: 'statistics', name: 'Statistics & Probability', subjectId: 'mathematics' },
      { id: 'vectors', name: 'Vectors & 3D Geometry', subjectId: 'mathematics' }
    ]
  },
  {
    id: 'biology',
    name: 'Biology',
    chapters: [
      { id: 'cell-biology', name: 'Cell Biology', subjectId: 'biology' },
      { id: 'genetics', name: 'Genetics', subjectId: 'biology' },
      { id: 'evolution', name: 'Evolution', subjectId: 'biology' },
      { id: 'ecology', name: 'Ecology', subjectId: 'biology' },
      { id: 'human-physiology', name: 'Human Physiology', subjectId: 'biology' },
      { id: 'plant-physiology', name: 'Plant Physiology', subjectId: 'biology' }
    ]
  }
];

export const TIME_SLOTS: TimeSlot[] = [
  { id: 'early-morning', label: 'Early Morning', startTime: '05:00', endTime: '07:00' },
  { id: 'morning', label: 'Morning', startTime: '07:00', endTime: '09:00' },
  { id: 'late-morning', label: 'Late Morning', startTime: '09:00', endTime: '11:00' },
  { id: 'pre-noon', label: 'Pre Noon', startTime: '11:00', endTime: '13:00' },
  { id: 'afternoon', label: 'Afternoon', startTime: '13:00', endTime: '15:00' },
  { id: 'late-afternoon', label: 'Late Afternoon', startTime: '15:00', endTime: '17:00' },
  { id: 'evening', label: 'Evening', startTime: '17:00', endTime: '19:00' },
  { id: 'night', label: 'Night', startTime: '19:00', endTime: '21:00' },
  { id: 'late-night', label: 'Late Night', startTime: '21:00', endTime: '23:00' }
];

export const STUDY_PATTERNS = [
  { id: 'morning', label: 'Study Mostly During Morning', value: 'morning' },
  { id: 'afternoon', label: 'Study Mostly During Afternoon', value: 'afternoon' },
  { id: 'evening', label: 'Study Mostly During Evening', value: 'evening' },
  { id: 'night', label: 'Study Mostly During Night', value: 'night' }
];

// Sample generated study plan data
export const generateSampleStudyPlan = () => {
  const tasks = [];
  const startDate = new Date();
  
  for (let day = 0; day < 7; day++) {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + day);
    
    // Morning slot
    tasks.push({
      id: `task-${day}-1`,
      subject: 'Physics',
      chapter: 'Mechanics',
      topic: 'Laws of Motion',
      duration: 120,
      priority: 'high' as const,
      type: 'study' as const,
      date: currentDate,
      timeSlot: 'morning'
    });
    
    // Evening slot
    tasks.push({
      id: `task-${day}-2`,
      subject: 'Mathematics',
      chapter: 'Calculus',
      topic: 'Derivatives',
      duration: 90,
      priority: 'medium' as const,
      type: 'practice' as const,
      date: currentDate,
      timeSlot: 'evening'
    });
  }
  
  return tasks;
};